<template lang="pug">
  v-card.order-modal__card.mx-auto.mt-0( max-width='100%' style="width: 100%;" )
    v-dialog(fullscreen="" v-model='basketDialog' max-width="500" persistent)
      v-btn(fab small color="primary" @click="basketDialog = false" style="position: absolute; z-index: 999; top: 10px; right: 0px;")
        v-icon.primary.rounded mdi-close
      BasketModal( :currentShopId="shop.data.id")
    v-dialog.dialog-detail-product(v-model='descriptionDialog' v-if="currentProduct && currentProduct.data" :fullscreen="isMobile" persistent)
      v-card.mx-auto.my-12(:loading="loading" max-width="500")
        v-card-title.dialog-close-detail-product
          v-spacer
            v-icon(aria-label="Close" @click="descriptionDialog = false")
              | mdi-close
        img.dialog-image-detail-product( :src="currentProduct.data.pictures.imageInput1")
        v-container.container-detail-product
          v-row
            v-col(cols="8")
              p.font-weight-bold.name-detail-product {{currentProduct.data && currentProduct.data.name ? currentProduct.data.name : 'no hay nombre' }}
            v-col(cols="4")
              p.font-weight-bold(style="color: #35a3a9") $ {{currentProduct.data && currentProduct.data.price && currentProduct.data.price.sale ? currentProduct.data.price.sale : 'no hay precio'}}
          v-row
            v-col
              p.font-weight-bold.description-detail-product Descripción
              v-row.mx-0(align="left")
                p.description-detail-product {{currentProduct.data && currentProduct.data.description ? currentProduct.data.description  : 'Este producto no cuenta con una descripcion por el momento' }}
          v-card-actions.justify-center
            p.text-center.red--text( v-if='currentProduct && getStock(currentProduct.data) == "0" && currentProduct.data.type !== "service"') Este producto esta agotado
            v-btn(color="primary" rounded style="padding: 10px !important" v-if="!isInCart" :disabled="currentProduct && getStock(currentProduct.data) == '0' && currentProduct.data.type !== 'service'" @click="addToCart(currentProduct)") Agregar a la canasta
            v-row.justify-center(v-if="isInCart")
              //- creo que aqui no debe ser currentProduct ya que este viene del inventario y no de el carrito
              v-btn(icon='' color='primary' @click="quitAmount(cartIndex,producIndex,cartId, currentProduct)")
                v-icon mdi-minus
              p(v-if="!currentProduct.data.magnitude" style="padding: 2px; padding-top: 10px; margin-bottom: 0px;") {{currentProduct.amount}}
              v-text-field(v-else v-model="currentProduct.data.newAmount" style="max-width: 50px;margin: 0;padding: 0;" :rules="[rules.number, rules.minValue]" @change="updateAmount(cartIndex,producIndex,cartId, currentProduct)")
              v-btn(icon='' color='primary'  @click="addAmount(cartIndex,producIndex,cartId, currentProduct)")
                v-icon mdi-plus
      //-
        v-card(style="border: 1px solid;")
          v-card-title
            | Detalle del producto
            v-spacer
              v-icon(aria-label="Close" @click="descriptionDialog = false")
                | mdi-close
          v-card-text.body-1.text-center
            v-card(flat v-if='currentProduct.data && currentProduct.data.pictures.imageInput1 !== ""' column xs12).mt-4.text-xs-center.product--detail__product--img__img
              img( :src="currentProduct.data.pictures.imageInput1"  style="max-height: 200px; object-fit:contain;")
            v-layout(v-else="" column xs12)
              p.text-center sin imagen
              v-card.pa-1.mx-auto.mt-0.d-inline-flex.v-card--account(class='grey--text' outlined="" height="150" width="150")
                v-icon.mx-auto(size="96")
                  | mdi-close
            p Nombre: {{currentProduct.data && currentProduct.data.name ? currentProduct.data.name : 'no hay nombre' }}
            p Descripción:
            p {{currentProduct.data && currentProduct.data.description ? currentProduct.data.description  : 'Este producto no cuenta con una descripcion por el momento' }}
            p.text-center.red--text( v-if='currentProduct && getStock(currentProduct.data) == "0" && currentProduct.data.type !== "service"') Este producto esta agotado
            v-btn(color="primary" style="padding: 10px !important" v-if="!isInCart" :disabled="currentProduct && getStock(currentProduct.data) == '0' && currentProduct.data.type !== 'service'" @click="addToCart(currentProduct)") Agregar a la canasta
            v-row.justify-center(v-if="isInCart")
              //- creo que aqui no debe ser currentProduct ya que este viene del inventario y no de el carrito
              v-btn(icon='' color='primary' @click="quitAmount(cartIndex,producIndex,cartId, currentProduct)")
                v-icon mdi-minus
              p(v-if="!currentProduct.data.magnitude" style="padding: 2px; padding-top: 10px; margin-bottom: 0px;") {{currentProduct.amount}}
              v-text-field(v-else v-model="currentProduct.data.newAmount" style="max-width: 50px;margin: 0;padding: 0;" :rules="[rules.number, rules.minValue]" @change="updateAmount(cartIndex,producIndex,cartId, currentProduct)")
              v-btn(icon='' color='primary'  @click="addAmount(cartIndex,producIndex,cartId, currentProduct)")
                v-icon mdi-plus
    v-btn(v-show='$route.name !== "shop"' fab small color="primary" @click="$emit('closeModalOrder')" style="position: absolute; z-index: 999; top: 10px; right: 0px;")
      v-icon.primary.rounded mdi-close
    v-btn(v-show='$route.name === "shop" && isMobile' fab small color="#009da5" @click="$router.go(-1)" style="position: absolute; z-index: 999; top: 10px; left: 10px;")
      v-icon(size="25") mdi-arrow-left
    v-img.white--text.align-end(height='140px' :src="getShopImage(bannerImgShop, 'banner')" style="overflow: visible; object-fit: cover; max-width: 1440px; margin: 0 auto;")
      .store-title.mx-3(style="position:absolute; bottom: -30px;")
        v-avatar(style="border: 4px solid #fff;" size="60")
          v-img(:src="getShopImage(imgShop)")
    .display-2.text-left.ml-4.pl-16(v-if="isMobile") {{shop.data.name}}
      v-icon.mx-2(size="30" color="#018786" @click="openRTC(shop)") mdi-message-video
      v-btn.mr-2(v-if="!favorite" @click="addFavorites(shop.data)" dark="" small="" color="primary")
        v-icon(dark="")
          | mdi-heart
      v-btn.mr-2(v-else @click="removeFavorites(shop.data)" dark="" small="" color="primary")
        v-icon(color="red")
          | mdi-heart
    v-card-text.pt-0.text--primary.order-modal__card__text(:class="$route.name === 'shop' && isMobile ? 'pt-0' : 'pt-2'" style="max-width: 1440px; margin: 0 auto;").px-0
      v-row.order-modal__container
        v-col(cols="12" lg="3").pt-0
          v-row.py-0
            v-col(cols="12").text-left.py-0.mt-5
              // Shop title
              v-list(v-if="!isMobile").m-0.p-0
                v-list-item.text-left
                  v-list-item-content
                    .display-2.text-left(v-if="!isMobile") {{shop.data.name}}
                  div(v-if="user" style="justify-content: center;display: flex;")
                    v-list-item-icon(@click="openRTC(shop)")
                      v-icon(size="30" color="#018786") mdi-message-video
                    v-list-item-icon(v-if="!favorite" @click="addFavorites(shop.data)")
                      v-btn(dark="" small="" color="primary")
                        v-icon(dark="")
                          | mdi-heart
                    v-list-item-icon(v-else @click="removeFavorites(shop.data)")
                      v-btn(dark="" small="" color="primary")
                        v-icon(color="red")
                          | mdi-heart
              // Shop description
              v-card-text.py-0
                template(v-if="!isMobile")
                  span.mb-0 {{shop.data.description}}
                  p.mt-2
                    v-icon.mr-2 mdi-bike-fast
                    b(v-if="shop.data.domicileValue") Domicilio: $ {{shop.data.domicileValue | numberFormat}}
                    b.ml-5 30-45 min
                    br
                    b(v-if="shop.data.minOrderValue") Pedido mínimo: $ {{shop.data.minOrderValue | numberFormat}}
                v-row
                  template(v-if="isMobile")
                    p.mr-4
                      v-icon.mr-2 mdi-bike-fast
                      b(v-if="shop.data.domicileValue") Domicilio: $ {{shop.data.domicileValue | numberFormat}}
                      b.ml-5 30-45 min
                      br
                      b(v-if="shop.data.minOrderValue") Pedido mínimo: $ {{shop.data.minOrderValue | numberFormat}}
                  v-icon mdi-share-variant
                  ShareNetwork(
                  v-for="network in networks"
                  :network="network.network"
                  :key="network.network"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  ).mx-2
                    v-icon(size="30" color="primary") {{network.icon}}
          //- PreviewBasket(v-if='!isMobile').pt-0.mt-0
          BasketModal(v-if='!isMobile'  :currentShopId="shop.data.id") <!-- @valid="validAmounts = $event" @getcart="getDataCart" para el paymentwizard -->
          //- .category-carousel( v-if='!isMobile' style="position:sticky; top: 0;").pb-0.mb-0
          //-   div(v-for="cat in shop.category")
          //-     .category-carousel__item(v-if="getItemsByCategory(cat.name).length > 0" @click="scrollTo(cat.name)")
          //-       span() {{cat.name}}
        v-col(cols="12" lg="9").pa-0
          v-tabs(v-model="tab" dark="" background-color="#019199" show-arrows)
            v-tab Productos
            v-tab(v-if="isMobile && shop.data.description") Descripción de la tienda
            v-tab(v-if="about.length > 0") Acerca de la tienda
            v-tab(v-if="posts.length > 0") Blog
            v-tab(v-if="multimedia.length > 0") Multimedia
          v-tabs-items(v-model="tab").pb-4
            v-tab-item
              .category-carousel(v-if='isMobile' style="position:sticky; top: 0; border-radius: 0;").pb-0.mb-0.ml-0
                div(v-for="cat in shop.category")
                  .category-carousel__item(v-if="getItemsByCategory(cat.name).length > 0" @click="scrollTo(cat.name)").text-center.pa-2
                    span() {{cat.name}}
              .category-list(v-else)
                template(v-for="section in shop.category")
                  div(v-if="getItemsByCategory(section.name).length > 0" @click="scrollTo(section.name)").category
                    img(:src="getImage(section.pictures.imageInput1)").category__img
                    span.category__title {{section.name}}
              v-row(style="padding: 10px 0px 0px 5px; margin: 0px; overflow-x: hidden;" ref="card__container").product-card__container
                v-col(v-if="loadingProducts" cols="12"  style="overflow: hidden").text-center
                  v-row.my-2
                    v-skeleton-loader( width='100%' type="list-item-avatar-two-line").mx-auto
                  v-row.my-2
                    v-skeleton-loader( v-for='i in 6' max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
                  v-row.my-2
                    v-skeleton-loader(  width='100%' type="list-item-avatar-two-line").mx-auto
                  v-row.my-2
                    v-skeleton-loader(v-for='i in 6'  max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
                  v-row.my-2
                    v-skeleton-loader(  width='100%' type="list-item-avatar-two-line").mx-auto
                template(v-else)
                  v-col(v-for="section in shop.category" :key='section.name' cols="12")
                    div(v-if="getItemsByCategory(section.name).length > 0")
                      .display-3.category-section(:ref='section.name') {{section.name}}
                      div(style=" overflow-x: auto;").pl-4
                        v-row(style="width: max-content;").px-0.justify-space-around.justify-lg-start
                          v-col( v-for='(inventory, i) in getItemsByCategory(section.name)' :key='i').pa-1.py-2
                            v-card(@click="showDescription(inventory)").product-card
                              p.product-card__tag(style=" margin-bottom: 0px;") {{shortenTitle(inventory.data.name)}}
                              .product-card__content
                                .product-card__background
                                    v-img(contain height='100px' :lazy-src='getImage(inventory.data.pictures.imageInput1)' :src='getImage(inventory.data.pictures.imageInput1)')
                                div(:class="getStock(inventory.data) == '0' && inventory.data.type !== 'service'? 'product-card__money-tag mt-1' : 'product-card__money-tag'")
                                  span.product-card__money-tag__sign $
                                  span {{inventory.data.price.sale | numberFormat}}{{( inventory.data.magnitude ? ' x ' + inventory.data.unit : '') }}
                                p.text-center.red--text( v-if='getStock(inventory.data) == "0" && inventory.data.type !== "service"' class="text-caption") agotado
                              div
                                .product-card__addBtn.mt-2(v-if="getStock(inventory.data) != '0' || inventory.data.type === 'service'" @click.prevent.stop="addToCart(inventory)")
                                  .product-card__addBtn-container
                                    span +
            v-tab-item(v-if="isMobile && shop.data.description")
              v-row.pa-4
                v-col(cols="12")
                  span.mb-0 {{shop.data.description}}
            v-tab-item(v-if="about.length > 0")
              v-row(justify="space-around")
                v-col(cols="5")
                  v-img(:src="about[0].image")
              v-row(justify="center")
                h1 {{ about[0].title }}
              v-row(justify="center")
                h2 {{ about[0].subject }}
              v-row(justify="center" style='margin-left: 10%; width: 80%;')
                v-container(v-html="about[0].content")
            v-tab-item(v-if="posts.length > 0")
              v-dialog(v-model='openPost'  max-width='600px'  :fullscreen='isMobile' )
                div(style ='position:relative; height: 100%; max-width:100%;')
                  v-btn.mt-2.ml-2(medium light fab='', absolute, left style='z-index:9999'  @click.native='openPost = false')
                    v-icon mdi-close
                  itemComponent()
              v-container(fluid="").pr-8
                v-row(dense="")
                  v-col(v-for="(post, i) in posts" :key="i" cols="12" md="6" lg="6").post__card
                    v-card(@click="openPostModal(post.id)")
                      v-img.white--text.align-end(:src="post.image" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px").post__card__img
                        v-card-title(v-text="post.title")
            v-tab-item(v-if="multimedia.length > 0")
              v-row
                template(v-for="(image, i) in multimedia")
                  v-col(:key="i" cols="12" xs="6" md="4" lg="3")
                    img(:src="image.href" loading="lazy" :class="isMobile ? '': 'multimedia__img'" @click="openMultimedia(image)")
              v-overlay(absolute :value="multimediaDialog")
                v-dialog(v-model="multimediaDialog" max-width="600px" :fullscreen="isMobile")
                  v-card(background-color="#f7f7f7").mx-auto
                    v-img(:src="selectedMultimedia.href").multimedia__gallery__img
                      v-btn(text small @click="multimediaDialog = false").multimedia__gallery__close-btn
                        v-icon(color="#019199") mdi-close
                    v-card-title(color="") {{selectedMultimedia.title}}
                    v-card-subtitle.mt-4 {{selectedMultimedia.description}}
        //- v-col.d-flex.justify-center(v-if="isMobile" :style="$route.name === 'shop' ? 'position: fixed; bottom: 50px; background-color: white; left: 0;' : 'position: fixed; bottom: 0px; background-color: white; left: 0;'")
        PreviewBasket(v-if='isMobile' @openbasket="basketDialog = true" :currentShopId="shop.data.id").pt-0.mt-0
</template>
<script>
  // import { mapActions } from 'vuex'
  import * as vars from '@/vars.json'
  import productPlaceHolder from '@/assets/icons/products.png'
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  import bannerPlaceHolder from '@/assets/images/background-tender.png'
  import Gallery from 'vue-cover-gallery'
  import itemComponent from '@/views/custom/shops-content/Post'
  import BasketModal from '@/views/marketplace/components/BasketModal'

  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    name: 'Shop',
    components: {
      itemComponent,
      productPlaceHolder,
      shopPlaceHolder,
      Gallery,
      PreviewBasket: () => import('@/views/marketplace/components/PreviewBasket'),
      // WebRtc: () => import('@/views/marketplace/components/core/VideoChat'),
      BasketModal: BasketModal,
    },
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value).slice(3)
      },
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    props: {
      shop: Object,
    },
    data () {
      return {
        basketDialog: false,
        validAmounts: true,
        allAboveMinimum: true,
        rules: {
          number: value => {
            return /^[0-9]+([,.][0-9]+)?$/g.test(value) || 'Cifra invalida.'
          },
          minValue: value => {
            return value >= 1 || 'Valor minimo debe ser igual a 1'
          },
        },
        cartIndex: -1,
        producIndex: -1,
        cartId: '',
        loadingProducts: false,
        descriptionDialog: false,
        isInCart: false,
        currentProduct: {
          location: [],
          data: {
            name: '',
            pictures: {},
          },
        },
        openPost: false,
        animated: false,
        arrCart: [],
        dialogRTC: false,
        imgShop: '',
        bannerImgShop: '',
        tab: null,
        totalProducts: 0,
        totalPrice: 0,
        inventories: [],
        favorite: false,
        multimediaDialog: false,
        selectedMultimedia: {},
      }
    },
    computed: {
      sharing () {
        return {
          url: `${vars.url}/getStore/${this.shop.data.subdomain}`,
          title: this.shop.data.name,
          description: this.shop.data.description,
          quote: 'Visita la tienda virtual',
          hashtags: 'tendershop',
        }
      },
      networks () {
        return [
          { network: 'facebook', name: 'Facebook', icon: 'mdi-facebook', color: '#1877f2' },
          { network: 'whatsapp', name: 'Whatsapp', icon: 'mdi-whatsapp', color: '#25d366' },
        ]
      },
      user () {
        return this.$store.state.users.user
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      favorites () {
        return this.$store.getters['shops/getFavorites']
      },
      posts () {
        return this.$store.getters['cms/getShopPosts']
      },
      about () {
        return this.$store.getters['cms/getShopAbout']
      },
      multimedia () {
        return this.$store.getters['cms/getShopMultimedia']
      },
      cart () {
        const vm = this
        return vm.$store.getters['pos/getCart']
      },
      coupon () {
        const vm = this
        return vm.$store.getters['promotions/getCoupon']
      },
    },
    mounted () {
      const vm = this
      if (vm.shop.data.img) {
        if (vm.shop.data.img.imageInput1) {
          vm.imgShop = vm.shop.data.img.imageInput1
        }
        if (vm.shop.data.img.imageInput2) {
          vm.bannerImgShop = vm.shop.data.img.imageInput2
        } else {
          vm.bannerImgShop = vm.shop.data.img.imageInput1
        }
      } else {
        vm.imgShop = 'https://cdn.vuetifyjs.com/images/cards/docks.jpg'
        vm.bannerImgShop = 'https://cdn.vuetifyjs.com/images/cards/docks.jpg'
      }
      vm.getDataCart()
      vm.$store.commit('cms/setLoading', true)
      vm.$store.dispatch('cms/loadItems', `shop-posts,${vm.shop.data.uid},${vm.shop.data.id}`).then(() => {
        // // console.log('Post de la tienda cargados', vm.posts)
        vm.$store.commit('cms/setLoading', false)
      })
      vm.$store.dispatch('cms/loadItems', `shop-about,${vm.shop.data.uid},${vm.shop.data.id}`).then(() => {
        // // console.log('About Us de la tienda cargado', vm.about)
        vm.$store.commit('cms/setLoading', false)
      })
      vm.$store.dispatch('cms/loadItems', `shop-multimedia,${vm.shop.data.uid},${vm.shop.data.id}`).then(() => {
        // // console.log('Multimedia de la tienda cargada', vm.multimedia)
        vm.$store.commit('cms/setLoading', false)
      })
    },
    created () {
      const vm = this
      // console.log(this.shop)
      vm.getInventory()
      vm.validateFavorites()
      vm.shop.category.sort(function (a, b) {
        if (a.name < b.name) { return -1 }
        if (a.name > b.name) { return 1 }
        return 0
      })
      // // console.log(vm.shop.category)
    },
    methods: {
      addAmount (index1, index2, idShop, product) {
        let newAmount
        if (product.data.magnitude) {
          newAmount = (parseFloat(product.data.newAmount) + 0.1).toFixed(1)
        } else {
          newAmount = (parseFloat(product.data.newAmount) + 1).toFixed(0)
        }
        const hasMagnitude = !!product.data.magnitude
        this.$store.dispatch('pos/addAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
          this.getDataCart()
        })
      },
      quitAmount (index1, index2, idShop, product) {
        let newAmount
        if (product.data.magnitude) {
          newAmount = (parseFloat(product.data.newAmount) - 0.1).toFixed(1)
        } else {
          newAmount = (parseFloat(product.data.newAmount) - 1).toFixed(0)
        }
        const hasMagnitude = !!product.data.magnitude
        this.$store.dispatch('pos/quitAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
          this.getDataCart()
        })
      },
      updateAmount (index1, index2, idShop, product) {
        const vm = this
        const isNumber = /^[0-9]+([,.][0-9]+)?$/g.test(product.data.newAmount)
        const isAboveOne = product.data.newAmount >= 1
        if (isNumber && isAboveOne) {
          const newAmount = (parseFloat(product.data.newAmount)).toFixed(1)
          const hasMagnitude = !!product.data.magnitude
          product.data.validInputAmount = true
          if (parseFloat(newAmount) > parseFloat(product.amount)) {
            vm.$store.dispatch('pos/addAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
              vm.getDataCart()
            })
          } else if (parseFloat(newAmount) < parseFloat(product.amount)) {
            vm.$store.dispatch('pos/quitAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
              vm.getDataCart()
            })
          }
        } else {
          product.data.validInputAmount = false
        }
      },
      showDescription (item) {
        const vm = this
        // console.log(item)
        vm.descriptionDialog = true
        vm.currentProduct = item
        vm.isInCart = false
        for (let i = 0; i < vm.arrCart.length; i++) {
          const shop = vm.arrCart[i]
          for (let j = 0; j < shop.inventory.length; j++) {
            const product = shop.inventory[j]
            if (product.id === item.id) {
              vm.cartIndex = i
              vm.producIndex = j
              vm.cartId = shop.id
              vm.isInCart = true
            }
          }
        }
      },
      getStock (product) {
        if (product && product.location && product.location[this.shop.id]) {
          return product.location[this.shop.id].stock || 0
        }
        return 0
      },
      openRTC (shop) {
        const vm = this
        vm.$store.dispatch('storefront/setCurrentShop', shop).then(() => {
          window.scrollTo(0, 0)
          vm.$store.dispatch('dialogs/openDialog', 'webRTC')
        })
      },
      validateFavorites () {
        const vm = this
        let found = null
        if (vm.favorites) {
          found = vm.favorites.find(element => element.id === vm.shop.data.id)
        }
        if (found) {
          vm.favorite = true
        } else {
          vm.favorite = false
        }
      },
      addFavorites (shop) {
        const vm = this
        // // console.log(shop)
        vm.$store.dispatch('shops/addToFavorites', shop).then(() => {
          // // console.log('add')
          vm.validateFavorites()
        })
      },
      removeFavorites (shop) {
        const vm = this
        // // console.log(shop)
        vm.$store.dispatch('shops/removeFavorites', shop).then(() => {
          // // console.log('remove')
          vm.validateFavorites()
        })
      },
      animate () {
        this.animated = true
      },
      scrollTo (ref) {
        // // console.log(ref)
        if (window.innerWidth < 1025) {
          this.$refs.card__container.scrollTop = this.$refs[ref][0].offsetTop - window.innerHeight * 0.45 + 280
        } else {
          this.$refs.card__container.scrollTop = this.$refs[ref][0].offsetTop - 20
        }
        // // console.log(this.$refs[ref][0], this.$refs.card__container, this.$refs[ref][0].offsetTop, this.$refs[ref][0].innerHeight)
        // this.$refs[ref].scrollIntoView()
      },
      getItemsByCategory (cat) {
        const results = []
        const vm = this
        vm.inventories.forEach(function (element) {
          try {
            element.data.categories.forEach(function (category) {
              if (cat === category.name) {
                results.push(element)
              }
            })
          } catch (err) {
            // // console.log('articulo no formateado con nuevas categorias')
          }
        })
        return results
      },
      getInventory () {
        const vm = this
        vm.loadingProducts = true
        // // console.log(vm.shop)
        const data = {
          uid: vm.shop.data.uid,
          idShop: vm.shop.data.id,
        }
        vm.$store.dispatch('shops/getUserInventory', data).then(res => {
          // // console.log(res.data)
          vm.loadingProducts = false
          if (res.data) {
            vm.inventories = res.data
            // console.log(vm.loadingProducts)
          }
        })
      },

      /* getDataCart () {
        this.arrCart = this.$store.getters['pos/getCart']
        this.totalProducts = 0
        this.totalPrice = 0
        for (let i = 0; i < this.arrCart.length; i++) {
          for (let j = 0; j < this.arrCart[i].inventory.length; j++) {
            this.totalPrice = (parseFloat(this.totalPrice) + (parseFloat(this.arrCart[i].inventory[j].data.price.sale)) * (parseFloat(this.arrCart[i].inventory[j].amount))).toFixed(0)
            this.totalProducts = (parseFloat(this.totalProducts) + (parseFloat(this.arrCart[i].inventory[j].amount)))
          }
        }
      }, */
      getDataCart () {
        const vm = this
        vm.arrCart = vm.cart
        vm.totalProducts = 0
        vm.totalPrice = 0
        for (let i = 0; i < vm.arrCart.length; i++) {
          vm.arrCart[i].subtotal = 0 // agregado solo para la confirmacion de la orden
          for (let j = 0; j < vm.arrCart[i].inventory.length; j++) {
            vm.arrCart[i].subtotal = (parseFloat(vm.arrCart[i].subtotal) + (parseFloat(vm.arrCart[i].inventory[j].data.price.sale)) * (parseFloat(vm.arrCart[i].inventory[j].amount))).toFixed(2)
            vm.totalProducts = (parseFloat(vm.totalProducts) + (parseFloat(vm.arrCart[i].inventory[j].amount)))
          }
          vm.totalPrice += +vm.arrCart[i].subtotal
        }
        if (vm.coupon !== null) {
          if (vm.coupon.isPorcentual) {
            vm.totalPrice = (vm.totalPrice * (100 - vm.coupon.value)) / 100
          } else {
            vm.totalPrice = vm.totalPrice - vm.coupon.value
            if (vm.totalPrice < 0) {
              vm.totalPrice = 0
            }
          }
        }
        vm.allOrdersAboveMinimumValue()
      },
      allOrdersAboveMinimumValue () {
        const vm = this
        // console.log('me ejecute')
        vm.allAboveMinimum = true
        for (let i = 0; i < vm.cart.length; i++) {
          const minValue = +vm.cart[i].minOrderValue || 0
          if (+vm.cart[i].subtotal < minValue) {
            vm.allAboveMinimum = false
          }
        }
        return vm.allAboveMinimum
      },
      addToCart (inventory) {
        // // console.log(this.shop)
        const vm = this
        /* const inventoryShop = {
          id: vm.shop.data.id,
          uid: vm.shop.data.uid,
          name: vm.shop.data.name,
          pictures: vm.shop.data.img,
          inventory: inventory,
          addressInfo: {
            addressgoogle: vm.shop.data.addressgoogle,
            lat: vm.shop.data.location.lat,
            lng: vm.shop.data.location.lng,
          },
          minOrderValue: vm.shop.data.minOrderValue || 0,
          context: 'order',
        } */
        const inventoryShop = {
          ...vm.shop.data,
        }
        inventoryShop.addressInfo = {
          addressgoogle: vm.shop.data.addressgoogle,
          lat: vm.shop.data.location.lat,
          lng: vm.shop.data.location.lng,
        }
        inventoryShop.context = 'order'
        inventoryShop.inventory = inventory
        inventoryShop.pictures = vm.shop.data.img
        inventoryShop.minOrderValue = vm.shop.data.minOrderValue || 0
        // // console.log(inventoryShop)
        vm.$store.dispatch('pos/addToCart', inventoryShop).then(async () => {
          // // console.log(vm.$store.getters['pos/getCart'])
          vm.animate()
          await vm.getDataCart()
          vm.isInCart = false
          for (let i = 0; i < vm.arrCart.length; i++) {
            const shop = vm.arrCart[i]
            for (let j = 0; j < shop.inventory.length; j++) {
              const product = shop.inventory[j]
              if (product.id === inventory.id) {
                vm.cartIndex = i
                vm.producIndex = j
                vm.cartId = shop.id
                vm.isInCart = true
              }
            }
          }
        })
      },
      closeModalBasket () {
        this.dialogBasket = false
        this.getDataCart()
      },
      getImage (item) {
        if (item) {
          return item
        } else {
          return productPlaceHolder
        }
      },
      getShopImage (item, additional) {
        if (item) {
          return item
        } else {
          if (!additional) {
            return shopPlaceHolder
          } else {
            return bannerPlaceHolder
          }
        }
      },
      openPostModal (id) {
        const vm = this
        const context = `users/${vm.shop.data.uid}/shops/${vm.shop.data.id}/posts`
        this.$store.dispatch('cms/getItem', { context, id }).then(function () {
          vm.openPost = true
        })
      },
      openMultimedia (image) {
        this.multimediaDialog = true
        this.selectedMultimedia = image
      },
      shortenTitle (title) {
        let newTitle = title
        if (title.length > 50) {
          newTitle = title.substring(0, 50) + '...'
        }
        return newTitle
      },
    },
    head: {
      title: function () {
        return {
          inner: this.metaParams.title,
          separator: ' ',
          complement: ' ',
        }
      },
      meta: function () {
        return [
          { name: 'application-name', content: 'ultimahoracol.com' },
          { name: 'description', content: 'vea las ultimas noticias' },
          { name: 'twitter:title', content: this.metaParams.title },
          { n: 'twitter:description', c: 'vea las ultimas noticias' },
          { property: 'fb:app_id', content: '1041870729355448' },

          { property: 'og:title', content: this.metaParams.title },
          { property: 'og:url', content: 'https://ultimahoracol.com' },
          { property: 'og:image', itemprop: 'image', content: this.metaParams.image },
          { property: 'og:description', content: this.metaParams.title },
          { property: 'og:site_name', content: 'Ultimahora colombia' },

        ]
      },
    },
  }
</script>
<style lang="scss" scoped>
  .description-detail-product{
    text-align: left !important;
  }
  .name-detail-product {
    word-break: keep-all !important;
    text-align: left !important;
  }
  .container-detail-product{
    padding: 12px !important;
  }
  .dialog-detail-product {
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .dialog-close-detail-product {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    left: 0;
    padding: 0;
  }
  .dialog-image-detail-product {
    margin: 0 auto;
    max-height: 271px;
    width: 100%;
    object-fit: contain;
    // border: 1px solid;
    border-bottom-right-radius: 50px;
  }
  .v-dialog{
    @media(min-width: 1024px){
      /*padding: 20px;*/
    }
  }
  .product--detail {
    &__title {
      background: rgb(45,180,188);
      background: linear-gradient(90deg, rgba(45,180,188,1) 0%, rgba(87,101,190,1) 100%);
      color: white;
      font-weight: 800;
      border-radius: 5px;
      text-transform: uppercase;
    }

    &__product--name {
      padding-top: 3rem;
      padding-bottom: 4px;
      font-weight: 500;
      text-transform: uppercase;
      font-weight: 800;
      font-size: 1.7rem;
      color: #30b4bb;
      display: inline-block;
    }

    &__info--name {
      font-weight: 500;
      font-weight: 800;
      font-size: 1.6rem;
      color: #696969;
      display: inline-block;

      &__border {
        padding-bottom: 0px !important;
        border: 2px #c9c9c9 solid;
        border-radius: 5px;
        font-size: 1.2rem;
      }
    }

    &__product--img {
      padding-top: 2rem;
      border-radius: 30px;
      &__img {
        left: 50%;
        transform: translate(-50%, 0);
      }

      &__btn {
        top: 1rem;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

    &__margin {
      border-bottom: 1px solid #e6e6e6;
    }

    &__info {
      padding-top: 0;
      font-weight: 100;
      font-size: 0.9rem;
      //color: #525252;
      color: #939393;
      display: inline-block;
    }

    &-product__card {
      height: 403;
      width: 302;
      margin-bottom: 24px;
      padding: 12px;
      display: inline-block;
      border-width: 4px;
      border-radius: 25px;
    }
  }
  .order-modal{
    &__tabs {
      background: rgb(1,145,153) !important;
      background: linear-gradient(180deg, rgba(1,145,153,1) 0%, rgba(0,173,179,1) 100%) !important;
    }
    &__card {
      &__text{
        padding: 0;
        padding-bottom: 60px;
        overflow:hidden;
        position:relative;
        @media(min-width: 1024px){
          padding-bottom: 0 !important;
        }
      }
      &.isShop{
        margin-bottom: 80px;
      }
    }
  }
  .category-list{
    margin: 0 auto;
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    max-width: 100%;
    margin-left: 0.6rem;
  }

  .category {
    border-radius: 10px;
    text-align: center;
    display: inline-block;
    margin: 0.5rem 0.7rem 0 0.7rem;
    min-width: 4rem;

    &__img {
      display: block;
      object-fit: cover;
      margin: auto;
      box-shadow: 1px 3px 3px rgba(0,0,0,0.3);
      border-radius: 10px;
      height: 3.5rem;
      width: 3.5rem;
    }

    &__title {
      margin: 0.5rem 0;
      display: block;
      font-size: 0.7rem;
      margin-top: 0.4rem;
      max-width: 4rem;
      display: inline-flex;
    }
    }
  .category-section{
    border-radius: 10px;
    margin: 0 -17px 10px;
    padding: 0 17px;
    color: #fff;
    background: linear-gradient(#009098, #00aeb4);
    @media(min-width: 1024px){
      margin: unset;
    }
  }
  .category-carousel{
    border: 2px solid #2DB4BC;
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    max-height: 50px;
    min-height: 50px;
    width: auto;
    overflow-y: hidden;
    overflow-x: auto;
    margin-left: 1rem;
    align-items:center;
    justify-content: space-between;
    padding-bottom: 0;
    &__item{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 15px;
      color: #717171;
      padding-left: 2rem;
      margin: 0 15px ;
      font-weight: 500;
      padding-bottom: 0;
      border-bottom: 1px solid #dcdcdc;
      span{
        width: max-content;
      }
      &:hover, &.selected{
        background: #2cb6bc;
        cursor: pointer;
        color: white;
        border-bottom: transparent;
      }
    }
    @media(min-width: 1024px) {
      max-height: 31vh;
      flex-direction: column;
      overflow: auto;
      &__item{
        width: 20.7rem;
        display: flex;
        align-items: flex-start;
      }
    }

  }
  .product-card{
    transition: .3s;
    display: flex;
    flex-direction:column;
    height: 100%;
    min-height: 190px;
    max-height: 190px;
    max-width: 145px;
    min-width: 145px;
    border-radius: 16px !important;
    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.3) !important;
    position: relative;
    overflow: hidden;
    &__tag {
      line-height: 15px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 0;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;
      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }
    &__container{
      padding-bottom: 35px;
      max-height: 55vh;
      // overflow-y: auto;
      @media(min-width: 768px){
        height: 100%;
        overflow: auto;
      }
    }
    &__content{
      padding: 10px;
     //
    }
    &__background{
      max-height: 70px;
      width: 100px;
      margin: auto;
      overflow: hidden;
      border-radius: 12px;
     //
    }
    &__money-tag{
      font-size: 1em;
      font-weight: bold;
      &__sign{
        color: #01b9c0;
        margin-right: 5px;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 44px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 100px;
        height: 85px;
        margin-right: -35px;
        margin-bottom: -35px;
        background: #00b9c0;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;
        display: flex;
        flex-direction: column;
        span{
          font-size: 35px;
          margin-top: 15px;
          margin-left: 3px;
        }
      }
    }
  }
  .basket-btn {
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__container {
      bottom: 0;
      right: 0;
      left: 0;
      max-width: 100%;
      margin: 0 auto;
      background: inherit;
      &.isCart{
        bottom: 50px;
      }
      @media(min-width: 1024px){
        &.isCart {
          bottom: -60px;
        }
        &.modal-cart{
        background: transparent;
        right: 0;
        margin: 0;
        margin-left: auto;
        }
      }
    }
  }
  .store-cart{
    position: fixed;
    bottom: 0;
  }
  .store-title{
    display: flex;
    flex-direction: row;
  }
  .post {
    &__card {
      transition: all .5s;

      &:hover {
        transform: scale(1.025) translateY(-.35rem);
      }

      &__img {
        object-fit: cover;
      }
    }
  }
  .multimedia{
    &__img{
      width: 100%;
      height: 16.625rem;
      object-fit: cover;
    }

    &__gallery {
      &__img {
        position: relative;
      }

      &__close-btn {
        position: absolute;
        right: 1%;
        top: 2%;
      }
    }
  }
</style>
